import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../helpers/constants";
import { getCookie } from "../../helpers/cookies";

const commonApis = createApi({
    reducerPath: "commonApis",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getCookie("magiclock_admin_token");
            if (token) {
                headers.set("Authorization", `BEARER ${token}`);
            }
            return headers;
        },
    }),
    keepUnusedDataFor: 0,
    tagTypes: ["PaymentHistory"],
    endpoints: (build) => ({
        getDashboardCount: build.query({
            query: (params) => ({
                url: "/business/dashboard/admin-stats",
                method: "GET",
                params: params,
            }),
            transformResponse: (response) => response.result,
        }),
        handleImageUpload: build.mutation({
            query: (payload) => ({
                url: "/common/upload-single-image",
                method: "POST",
                body: payload,
                formData: true,
            }),
            transformResponse: (response) => response.result,
        }),
        handleMultipleImageUpload: build.mutation({
            query: (payload) => ({
                url: "/common/upload-multiple-image",
                method: "POST",
                body: payload,
                formData: true,
            }),
            transformResponse: (response) => response.result,
        }),
        getStaffLocations: build.query({
            query: () => ({
                url: "/common/staff-locations",
                method: "GET",
            }),
            transformResponse: (response) => response.result,
        }),
        getMonthlyReports: build.query({
            query: (params) => ({
                url: "/business/dashboard/monthly-reports",
                method: "GET",
                params: params,
            }),
            transformResponse: (response) => response.result,
        }),
        getYearlyReports: build.query({
            query: (params) => ({
                url: "/business/dashboard/yearly-reports",
                method: "GET",
                params: params,
            }),
            transformResponse: (response) => response.result,
        }),
        getEnhancedAnalytics: build.query({
            query: () => ({
                url: "/business/dashboard/enhanced-analytics",
                method: "GET",
            }),
            transformResponse: (response) => response.result,
        }),
    }),
});

export const {
    useGetDashboardCountQuery,
    useHandleImageUploadMutation,
    useHandleMultipleImageUploadMutation,
    useGetStaffLocationsQuery,
    useGetMonthlyReportsQuery,
    useGetYearlyReportsQuery,
    useGetEnhancedAnalyticsQuery,
} = commonApis;
export default commonApis;
